import { render } from "./MultipleChoice.vue?vue&type=template&id=c9599166&scoped=true&ts=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./MultipleChoice.vue?vue&type=style&index=0&id=c9599166&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-c9599166"]])

export default __exports__